import * as React from 'react';

import PencilBadge16 from './PencilBadge16';

export const pencilBadge16 = () => <PencilBadge16 />;

export default {
    title: 'Icon|Line|PencilBadge16',
    component: PencilBadge16,
    parameters: {
        notes: "`import PencilBadge16 from 'box-ui-elements/es/icon/line/PencilBadge16';`",
    },
};
